import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import PropTypes from 'prop-types';
import React, {useCallback, useState} from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {IconButton, Menu, MenuItem} from '@mui/material';

/**
 * This is used in the map popup, but for the collapsed and expanded views.
 * It allows copying of detection ID, model ID and image ID. If the values
 * are not present, the respective menu options will be disabled.
 */
const CopyMenuButton = ({fid, modelId, sourceItemId, size}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = useCallback(event => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <>
      <IconButton
        aria-label="more"
        aria-controls="copy-menu"
        aria-haspopup="true"
        color="inherit"
        onClick={handleClick}
        size={size}
      >
        <MoreHorizIcon fontSize={size} />
      </IconButton>
      <Menu
        id="copy-menu"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        open={!!anchorEl}
        onClose={handleClose}
        PaperProps={{
          style: {
            backgroundColor: '#000',
            color: '#fff',
          },
        }}
      >
        <CopyToClipboard text={fid}>
          <MenuItem key="detect" onClick={handleClose}>
            Copy detect ID
          </MenuItem>
        </CopyToClipboard>
        <CopyToClipboard text={modelId}>
          <MenuItem
            disabled={modelId === undefined}
            key="model"
            onClick={handleClose}
          >
            Copy model ID
          </MenuItem>
        </CopyToClipboard>
        <CopyToClipboard text={sourceItemId}>
          <MenuItem
            disabled={sourceItemId === undefined}
            key="image"
            onClick={handleClose}
          >
            Copy image ID
          </MenuItem>
        </CopyToClipboard>
      </Menu>
    </>
  );
};

CopyMenuButton.propTypes = {
  fid: PropTypes.string,
  modelId: PropTypes.string,
  sourceItemId: PropTypes.string,
  size: PropTypes.string,
};

export default CopyMenuButton;
